"use strict";

exports.__esModule = true;
exports.default = isArraysEqualEps;
function isArraysEqualEps(arrayA, arrayB, eps) {
  if (arrayA && arrayB) {
    for (var i = 0; i !== arrayA.length; ++i) {
      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
        return false;
      }
    }
    return true;
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/google-map-react/lib/utils/array_helper.js
// module id = 1530
// module chunks = 0